import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Company } from "../types";

interface CompaniesState {
  list: Company[];
  loading: boolean;
  error: string | null;
}

const initialState: CompaniesState = {
  list: [],
  loading: false,
  error: null,
};

const companiesSlice = createSlice({
  name: "companies",
  initialState,
  reducers: {
    fetchCompaniesStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchCompaniesSuccess(state, action: PayloadAction<Company[]>) {
      state.list = action.payload;
      state.loading = false;
    },
    fetchCompaniesFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    addCompany(state, action: PayloadAction<Company>) {
      state.list.push(action.payload);
    },
    updateCompany(state, action: PayloadAction<Company>) {
      const index = state.list.findIndex((c) => c.id === action.payload.id);
      if (index !== -1) state.list[index] = action.payload;
    },
    removeCompany(state, action: PayloadAction<number>) {
      state.list = state.list.filter((c) => c.id !== action.payload);
    },
  },
});

export const {
  fetchCompaniesStart,
  fetchCompaniesSuccess,
  fetchCompaniesFailure,
  addCompany,
  updateCompany,
  removeCompany,
} = companiesSlice.actions;
export default companiesSlice.reducer;
